export const isInovize = window.location.host.includes("inovize");
export const appBaseUrl = isInovize ? `https://api.inovize.in` : `https://api.sbtracking.com`;
// export const appBaseUrl = "http://localhost:3001"
const appApi = `${appBaseUrl}/api/v1`;

export const appTitle = isInovize ? "Inovize" : "S B Tracking";
export const appImages = {
    logo: isInovize ? "/assets/images/inovize-logo.png" : "/assets/images/sb-logo-app.jpg",
    gpsBanner: `/assets/e-sign/${isInovize ? "inovize-" : ""}gps-banner.png`,
    gpsFooter: `/assets/e-sign/${isInovize ? "inovize-" : ""}gps-footer.png`,
};

export const appApis = {
    login: `${appApi}/auth/login`,
    filters: `${appApi}/inventory/master-types`,
    suppliers: `${appApi}/supplier`,
    softwareProviders: `${appApi}/vehicles/software-provider`,
    billingCompanies: `${appApi}/vehicles/billing-companies`,
    wareHouse: `${appApi}/warehouses`,
    companies: `${appApi}/companies`,
    companiesRqType: `${appApi}/companies/list-all-request-types`,
    companiesRequest: `${appApi}/companies/request-logs`,
    createRequest: `${appApi}/companies/create-request-log`,
    updateRequest: `${appApi}/companies/update-request-log`,
    imeiDetails: `${appApi}/inventory/search`, //sp
    addInventory: `${appApi}/inventory/purchase`,
    getInstallerInv: `${appApi}/installers/inventory`, //sp
    getInventory: `${appApi}/inventory/get-all`,
    getInventoryCount: `${appApi}/inventory/count-by-types`,
    inventoryLog: `${appApi}/inventory/logs`, //change
    downloadData: `${appApi}/inventory/download-inventory-list`,
    downloadVehiclesData: `${appApi}/vehicles/download-vehicles-list`,
    downloadCompaniesData: `${appApi}/companies/download-company-list`,
    downloadRequestData: `${appApi}/companies/download-company-request-logs-list`,
    inventoryTransfer: `${appApi}/transfers/inventory`,
    addBilling: `${appApi}/vehicles/add-billing`,
    updateBilling: `${appApi}/vehicles/update-billing`,
    getInstallers: `${appApi}/installers`,
    getVehicleApi: `${appApi}/vehicles/get-vehicles`,
    searchVehicleApi: `${appApi}/vehicles/get-by-registration-number`,
    vehicleBilling: `${appApi}/vehicles/add-billing`,
    addVehicleApi: `${appApi}/vehicles/add-vehicle`,
    genrateVehicleInvoice: `${appApi}/vehicles/generate-vehcile-invoice`,
    vehicleRenwal: `${appApi}/vehicles/vehicles-renewals`, //sp
    updateVehileApi: `${appApi}/vehicles/update-vehicle`,
    uploadCompaniesCsv: `${appApi}/companies/upload-bulk`,
    uploadVehicleCsv: `${appApi}/vehicles/upload-bulk`,
    vehicleLogPayment: `${appApi}/vehicles/log-invoice-payment`,
    uploadInventoryCsv: `${appApi}/inventory/upload-bulk`,
    mappingCsv: `${appApi}/inventory/bulk-map`, //sp
    getUsers: `${appApi}/users`,
    getUserRoles: `${appApi}/users/user-roles`,
    addRole: `${appApi}/users/add-role`,
    updateRole: `${appApi}/users/update-role`,
    deleteRole: `${appApi}/users/delete-role`,
    pages: `${appApi}/users/pages`,
    createSupplier: `${appApi}/supplier`,
    invoiceList: `${appApi}/vehicles/invoice-list`, //sp
    inventoryDetails: `${appApi}/installers/inventory-stock-on-click`, //sp
    deleteInvoice: `${appApi}/vehicles/delete-invoice`,
    paymentLogs: `${appApi}/vehicles/get-invoice-payment-logs`, //sp
    vehicleStatus: `${appApi}/vehicles/change-status`,
    reminder: `${appApi}/notifications/formatted-template`,
    sendReminder: `${appApi}/notifications/send-reminder`,
    revertMapping: `${appApi}/inventory/revert-device-sim-map`,
    getQuotation: `${appApi}/vehicles/get-quotation`,
    generateQuotation: `${appApi}/vehicles/generate-quotation`,
    deleteQuotation: `${appApi}/vehicles/delete-quotation`,
    getVehicleActions: `${appApi}/vehicles/vehicle-actions`,
    dashboardReport: `${appApi}/inventory/dashboard`,
    addBillingCompany: `${appApi}/companies/create-billing-company`,
    updateBillingCompany: `${appApi}/companies/billing-company`,
    deleteBillingComapny: `${appApi}/companies/billing-company`,
    addInventoryTypes: `${appApi}/inventory/types`,
    addSimProviders: `${appApi}/sims/providers`,
    addSoftwareProvider: `${appApi}/inventory/add-software-provider`,
    addDeviceModal: `${appApi}/inventory/add-device-modal`,
    getProfile: `${appApi}/users/dealer-profile`,
    deleteInventoryTypes : `${appApi}/inventory/types`,
    deleteSimProviders : `${appApi}/sims/providers`,
    deleteSoftwareProvider : `${appApi}/inventory/software-provider`,
    deleteSupplier : `${appApi}/supplier`,
    deleteWarehouses : `${appApi}/warehouses`,
    deleteDeviceModal : `${appApi}/inventory/device-modal`,
    deleteInventory: `${appApi}/inventory/item`,
    installerReport: `${appApi}/installers/request-summary`,
    taskBaseApi: `${appApi}/tasks`,
    getWpSettings: `${appApi}/users/dealer-wp-setting`,
    createWpSettings: `${appApi}/users/dealer-create-wp-setting`,
    updateWpSettings: `${appApi}/users/dealer-update-wp-setting`,
}

export const dropdownDefaultList = {
    simStatus: [{ name: "Blank", id: 1 }, { name: "Activated", id: 2 }, { name: "Non-Activated", id: 3 }],
    confirmation: [{ name: "Yes", id: 1 }, { name: "No", id: 2 }],
    gstStatus: [{ name: "GST", id: 1 }, { name: "Non-GST", id: 2 }],
    employmentType: [{ name: "Salaried", id: 1 }, { name: "Per Request Charge", id: 2 }],
    billingCycle: [{ name: "Yearly", id: 1 }, { name: "Monthly", id: 2 }],
    gstPercentage: [{ name: "0%", id: 0 }, { name: "5%", id: 5 }, { name: "12%", id: 12 }, { name: "18%", id: 18 }, { name: "28%", id: 28 }],
    billingType: [{ name: "Rented", id: 1 }, { name: "Sell", id: 2 }],
    list: [{ name: "AIS140", id: 1 }, { name: "Others", id: 2 }],
    installerStatus: [{ name: "Active", id: 1 }, { name: "Inactive", id: 2 }, { name: "Terminated", id: 3 }],
    roles: [{ name: "Admin", id: 1 }, { name: "Stock Manager", id: 2 }, { name: "Billing Manager", id: 3 }],
    paymentMethod: [{ name: "Bank Transfer", id: 1 }, { name: "Cash", id: 2 }, { name: "UPI", id: 3 }, { name: "Cheque", id: 4 }],
    paymentStatus: [{ name: "Paid", id: 1 }, { name: "Partial", id: 2 }, { name: "Pending", id: 3 }],
    quotationType: [{ name: "Installation", id: 1 }, { name: "Sim Insert", id: 2 }],
}

export const headerColumn = {
    billingCompanies: ["Company Details", 'GST Type', 'GSTIN', 'HSN Code', 'SAC Code', 'Contact Info', 'Actions'],
    companies: ["Company Name", "Contact Person", "Mobile No.", "GST No.", "Date", "Outstanding Amount", "Action"],
    inventories: ["Inventory Type", "GPS IMEI", "Device Model", "Sim IMEI", "Sim No.", "Sim No. 2", "Sim Status", "State", "Action"],
    installers: ["Installer Name", "Mobile No", "Installer Type", "Status", "Action"],
    installersRequestSummary: ["Installer Name", "Employement Type", "Amount", "Request Completed", "Total Payment"],
    inventoryLogs: ["Transfer Type", "State", "Recipient", "Date"],
    users: ["Full Name", "Email", "Mobile No", "Role", "Status", "Created", "Action"],
    vehicles: ["Vehicle No", "Company Name", "GPS IMEI", "GPS Model", "SIM IMEI", "SIM No", "SIM No 2", "Installation Date", "Expiry Date", "Software Provider", "GST Applicable", "Billing Type", "Billing Cycle", "Billing Amount", "Billing Company", "Last Billing Date", "Renewal Amount", "Status", "Action"],
    companiesRq: ["Company Name", "Request Type", "Vehicle No", "GPS IMEI", "SIM No", "Installer Name", "Date", "Status", "Action"],
    renewals: ["Company Name", "Vehicle No", "Billing Cycle", "Billing Type", "Billing Amount", "GST Amount", "Total", "Due Date", "Billing Company"],
    payment: ["Date", "Company", "Invoice No", "Total Amount", "Amount Paid", "Method", "Status", "Remaining", "Action"],
    purchase: ["Inovice Date", "Invoice Number", "Supplier Name", "Total items", "Created Date"],
    installerInv: ["Installer Name", "Device Type", "Allocated", "Installed", "Remaining", "Last Allocation", "Status"],
    companyInv: ["Company Name", "Device Type", "Allocated", "Installed", "Remaining", "Last Allocation"],
    mapping: ["Current State", "GPS IMEI", "SIM IMEI", "SIM No", "Date"],
    transfer: {
        1: ["GPS IMEI", "Device Model", "SIM IMEI", "SIM No.", "Action"],
        2: ["GPS IMEI", "Device Model", "Action"],
        3: ["SIM IMEI", "SIM No.", "Action"]
    },
    imports: {
        companies: [
            { label: "company_name", value: "company_name", name: "Company Name" },
            { label: "contact_person", value: "contact_person", name: "Contact Person" },
            { label: "mobile_no", value: "mobile_no", name: "Mobile No." },
            { label: "gst_no", value: "gst_no", name: "GST No." },
            { label: "outstanding_amount", value: "outstanding_amount", name: "Outstanding Amount" },
        ]
    },
    inventoryDetails: ["Inventory Type", "GPS IMEI", "SIM IMEI", "SIM No.", "Transfer Mode", "Current State", "In Stock", "Last Transfer Date", "Is New", "Courier", "Remark", "Actions"],
    companyinventoryDetails: ["Inventory Type", "GPS IMEI", "SIM IMEI", "SIM No.", "Transfer Mode", "Current State", "In Stock", "Courier"],
    paymentDetails: ["Sl No.", "Invoice No.", "Payment Date", "Paid Amount", "Payment Mode", "Remarks", "Added Date", "Added By"],
    quotations: ["Quotation No", "Quotated Company", "Quotation Date", "Billing Company Name", "GST", "GST No.", "Items", "Billing Amount", "GST Amount", "Total Amount", "Action"],
}

export const csvUrls = {
    inventory: {
        1: "/assets/csv/gps_with_sim.csv",
        2: "/assets/csv/gps.csv",
        3: "/assets/csv/sim.csv",
        4: "/assets/csv/gps_with_sim_a140.csv",
        5: "/assets/csv/sim-blank.csv",
    },
    transfer: {
        1: "/assets/csv/gps_with_sim_transfer.csv",
        2: "/assets/csv/gps_transfer.csv",
        3: "/assets/csv/sim.csv",
    },
    mapping: "/assets/csv/mapping-gps.csv",
    import: {
        "companies": "/assets/csv/companies-import.csv",
        "vehicles": "/assets/csv/vehicle-import.csv",
        "inventories": {
            1: "/assets/csv/import-gps_with_sim.csv",
            2: "/assets/csv/import-gps.csv",
            3: "/assets/csv/import-sim.csv",
        },
    }
}

export const defaultCSVHeaders = {
    inventory: {
        1: [
            { label: "gps_imei_no", value: "gpsImeiNo", type: "imei" },
            { label: "sim_imei_no", value: "simImeiNo", type: "imei" },
            { label: "sim_no", value: "simNum", type: "phone" }
        ],
        2: [
            { label: "gps_imei_no", value: "gpsImeiNo", type: "imei" }
        ],
        3: [
            { label: "sim_imei_no", value: "simImeiNo", type: "imei" },
            { label: "sim_no", value: "simNum", type: "phone" },
        ],
        4: [
            { label: "gps_imei_no", value: "gpsImeiNo", type: "imei" },
            { label: "sim_imei_no", value: "simImeiNo", type: "imei" },
            { label: "sim_no", value: "simNum", type: "phone" },
            { label: "sim_no_2", value: "simTwoNum", type: "phone" }
        ],
        5: [
            { label: "sim_imei_no", value: "simImeiNo", type: "imei" }
        ],
    },
    transfer: {
        1: [
            { label: "gps_imei_no", value: "gpsImeiNo", type: "imei" },
            { label: "device_modal", value: "deviceModal", type: "text" },
            { label: "sim_imei_no", value: "simImeiNo", type: "imei" },
            { label: "sim_no", value: "simNum", type: "phone" }
        ],
        2: [
            { label: "gps_imei_no", value: "gpsImeiNo", type: "imei" },
            { label: "device_modal", value: "deviceModal", type: "text" }
        ],
        3: [
            { label: "sim_imei_no", value: "simImeiNo", type: "imei" },
            { label: "sim_no", value: "simNum" },
        ]
    },
    mapping: [
        { label: "gps_imei_no", value: "gpsImeiNo", type: "imei" },
        { label: "sim_no", value: "simNum", type: "phone" },
    ]
}

export const eSign = {
    "sbtracking": "/assets/e-sign/sbtracking.jpg",
    "shreebhagwatitracking": "/assets/e-sign/shreebhagwati.jpg",
    "shreebhavanitracking": "/assets/e-sign/shreebhavani.jpg",
    "inovize": "/assets/e-sign/inovize-stamp.png"
}